export default "__VITE_ASSET__BUseAk1F__"